"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTextFieldPassword = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsTextField = require("./DmsTextField");
var _PasswordRegexDescription = require("../../constants/PasswordRegexDescription");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
const _excluded = ["passwordRule_pk", "onValidationChange", "onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Password Text Field Component with Custom Validation.
 *
 * This component renders a password input field using the `DmsTextField` component.
 * It validates the password based on a specified rule from `PasswordRules`.
 * If `passwordRule_pk` is not provided, the component fetches the password rule via API from `login_settings`.
 *
 * @component
 * @param {Object} props - Properties passed to the component.
 * @param {number|null} [props.passwordRule_pk=null] - Primary key of the password rule to be used. If not provided, the rule is fetched from the API.
 * @param {Function|null} [props.onValidationChange=null] - Callback function called when the password validation state changes. Receives a boolean indicating whether the password is valid.
 * @param {Object} [props.props] - Additional properties to be passed to the `DmsTextField` component.
 *
 * @example
 * // Example usage of DmsTextFieldPassword
 * <DmsTextFieldPassword
 *   passwordRule_pk={PasswordRegexDescription.MIN_8_CHARACTERS_ALPHANUMERIC}
 *   onValidationChange={(isValid) => console.log(isValid)}
 *   label="Password"
 *   name="password"
 * />
 *
 * @returns {JSX.Element} A password input field with validation.
 */
const DmsTextFieldPassword = _ref => {
  let {
      passwordRule_pk = null,
      onValidationChange = null,
      onChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [password, setPassword] = (0, _react.useState)('');
  const [error, setError] = (0, _react.useState)('');
  const [rule, setRule] = (0, _react.useState)(_PasswordRegexDescription.PasswordRules[passwordRule_pk] || _PasswordRegexDescription.PasswordRules[1]);
  const [passwordRulePk, setPasswordRulePk] = (0, _react.useState)(passwordRule_pk);
  (0, _react.useEffect)(() => {
    if (!passwordRule_pk) {
      const fetchLogSetting = async () => {
        const url = "/login_settings";
        try {
          var _data$data;
          const {
            data
          } = await (0, _DmsFetch.fetchData)(url, "GET", true);
          const password_format_pk = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.password_format_pk;
          if (password_format_pk) {
            setRule(_PasswordRegexDescription.PasswordRules[password_format_pk]);
            setPasswordRulePk(password_format_pk);
          }
        } catch (e) {
          console.error("Error fetching ".concat(url, ": ").concat(e));
        }
      };
      fetchLogSetting();
    }
  }, []);
  const handleChange = e => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    if (onChange) {
      onChange(e);
    }
    debouncedValidation(newPassword);
  };
  (0, _react.useEffect)(() => {
    return () => {
      debouncedValidation.cancel();
    };
  }, []);
  const debouncedValidation = (0, _lodash.default)(newPassword => {
    if (!rule.test(newPassword)) {
      setError(_PasswordRegexDescription.PasswordRulesDescription[passwordRule_pk]);
      onValidationChange && onValidationChange(false);
    } else {
      setError('');
      onValidationChange && onValidationChange(true);
    }
  }, 300);
  return /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, _extends({
    onChange: handleChange,
    error: !!error,
    helperText: error,
    type: "password",
    fullWidth: true
  }, props));
};
exports.DmsTextFieldPassword = DmsTextFieldPassword;